<template>
  <div class="col-xs-12">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title"><i class="fa fa-user mr-5"></i>{{'users' | translate}}</h3>
        <div class="box-tools pull-right">
          <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button>
        </div>
      </div>
      <div class="box-controls">
        <button type="button" class="btn btn-info" data-toggle="modal" data-target="#new-user" @click="$parent.newUser = true"><i class="fa fa-plus-square mr-5"></i>{{'new_user' | translate}}</button>
        <my-pagination :total="users.total" :per-page="users.per_page" :pagination="users"></my-pagination>
      </div>
      <div class="box-body">
        <div class="row">
          <div class="col-xs-12">
            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                <tr>
                  <th>{{'is_active' | translate}}</th>
                  <th>ID</th>
                  <th>e-mail</th>
                  <th>{{'username' | translate}}</th>
                  <th>{{'name' | translate}}</th>
                  <th>{{'roles' | translate}}</th>
                  <th>{{'edit' | translate}}</th>
                  <th>Myplace Login</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item, index in pagination.data">
                  <td>
                    <div class="btn-group btn-group-sm" data-toggle="btn-toggle">
                      <button type="button" :class="['btn btn-success btn-sm', item.is_active ? 'active' : '']" @click="toggleActivation(true, item.id, index)"><i class="fa fa-check"></i></button>
                      <button type="button" :class="['btn btn-danger btn-sm', !item.is_active ? 'active' : '']" @click="toggleActivation(false, item.id, index)"><i class="fa fa-ban"></i></button>
                    </div>
                  </td>
                  <td>{{item.id}}</td>
                  <td>{{item.email}}</td>
                  <td>{{item.username}}</td>
                  <td><p>{{item.first_name}} {{item.last_name}}</p></td>
                  <td><ul><li v-for="role in item.roles" v-if="role !== 'co_dashboard' && role !== 'co_accounting'">{{role | translate}}</li></ul></td>
                  <template v-if="isLoading">
                    <td>
                      <button class="btn btn-default btn-app no-margin" :disabled="isLoading"><i class="fa fa-spinner fa-spin"></i>{{'edit' | translate}}</button>
                    </td>
                    <td>
                      <button class="btn btn-default btn-app no-margin" :disabled="isLoading"><i class="fa fa-spinner fa-spin"></i>Myplace</button>
                    </td>
                  </template>
                  <template v-else>
                    <td>
                      <button class="btn btn-info btn-app no-margin" data-toggle="modal" data-target="#new-user" @click="propSelect(item)" :disabled="isLoading"><i class="fa fa-edit"></i>{{'edit' | translate}}</button>
                    </td>
                    <td>
                      <button class="btn btn-primary btn-app no-margin" @click="goToMyplace(item.id)" :disabled="isLoading"><i class="fa fa-sign-in"></i>Myplace</button>
                    </td>
                  </template>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="box-footer">
        <my-pagination :total="users.total" :per-page="users.per_page" :pagination="users"></my-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['id', 'pagination', 'loading'],
    data () {
      return {
        count: 25,
        stores: {},
        alerts: [],
        isActive: '',
        users: this.pagination,
        isLoading: this.loading
      }
    },
    methods: {
      paginate (type, value) {
        this.isLoading = true
        let url = '?preflight=kek'
        if (type === 'page') {
          url += '&page='
          if (value === 'previous') {
            url += (this.users.current_page - 1)
          }
          if (value === 'next') {
            url += this.users.current_page >= this.users.last_page ? this.users.last_page : (this.users.current_page + 1)
          } else if (value !== 'next' && value !== 'previous') {
            url += value
          }
        }
        API.get(`accounting/companies/${this.$route.params.id}/users${url}`)
          .then(response => {
            this.isLoading = false
            this.users = response.data
          })
      },
      toggleActivation (value, id, index) {
        let data = {
          is_active: value
        }
        this.pagination.data[index].is_active = value
        API.put(`accounting/companies/${this.id }/users/${id}`, data)
          .then(response => {
          })
      },
      goToMyplace (id) {
      	API.put(`accounting/companies/${this.id }/users/${id}/token-request`)
          .then(response => {
          	window.open(this.getURI() + '/home?auth_token=' + response.data.token)
          })
      },
	    getURI () {
		    let productionURLs = ['cs.qb-schuhe.de', 'qb-schuhe.de', 'qualibet-schuhe.de', 'qbschuhe.de', 'www.qb-schuhe.de', 'www.qualibet-schuhe.de', 'www.qbschuhe.de', 'myplace.schuhe.de']
		    if ((productionURLs.indexOf(window.location.hostname)) !== -1) {
			    return 'https://myplace.schuhe.de'
		    } else if (window.location.hostname === 'localhost' || window.location.hostname === 'qualibet.local') {
			    return 'http://qualibet.local:9090'
		    } else if (window.location.hostname === 'cs-frontend.test') {
          return 'http://myplace-frontend.test'
        } else if (window.location.hostname === 'cs.staging-qb.de') {
			    return 'https://myplace.staging-qb.de'
		    }
      },
      propSelect (item) {
        this.$emit('selectUser', {...item})
      }
    },
    mounted () {
      this.$nextTick(() => {
      })
    },
    watch: {
      loading () {},
      users (value) {
        this.$parent.users = value
      },
      pagination () {
        this.users = this.pagination
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/tools/Tables/UsersTable.vue